<template>
    <b-modal
        id="group-show-restore-custom-banner-modal"
        hide-header
        modal-class="clean-modal custom-swal-modal"
        content-class=""
        @ok="ok"
        hide-footer>
        <div class="swal-modal">
            <div class="swal-icon swal-icon--warning">
                <span class="swal-icon--warning__body">
                    <span class="swal-icon--warning__dot"></span>
                </span>
            </div>
            <div class="swal-title">{{ $t('group.restore_banner_confirmation_title') }}</div>
            <div class="swal-text">
                {{ $t('group.restore_banner_confirmation_body') }}<br />
                {{ $t('group.the_banner_will_be_image_below') }}

                <div class="default-banner">
                    <b-img :src="groupIn.course.image"></b-img>
                </div>
            </div>
            <div class="swal-footer">
                <div class="swal-button-container">
                    <b-button
                        class="swal-button swal-button--cancel"
                        variant="primary"
                        @click="cancel()"
                        >{{ $t('group.the_banner_will_be_image_below') }}</b-button
                    >
                </div>
                <div class="swal-button-container">
                    <b-button
                        class="swal-button swal-button--confirm"
                        variant="danger"
                        @click="ok()"
                        >{{ $t('common.yes_recover') }}</b-button
                    >
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-group-show-restore-custom-banner-component',
    props: {
        bannerIdIn: Number,
        groupIn: Object,
    },
    methods: {
        ok() {
            this.alert.saving();
            axios.post(this.routes.groupBannerRemove(this.groupIn.id, this.bannerIdIn)).then(
                (response) => {
                    this.alert.success();
                    window.location.href = `${this.routes.groupShow(this.groupIn.id)}`;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        cancel() {
            this.$bvModal.hide('group-show-restore-custom-banner-modal');
        },
    },
};
</script>

<style scoped>
div.swal-modal {
    opacity: 1;
    width: auto;
    height: auto;
    margin: 0;
    pointer-events: auto;
}

.default-banner {
    margin-top: 26px;
}

.default-banner img {
    width: 100%;
    height: 175px;
    object-fit: cover;
}

.swal-text:last-child {
    margin-bottom: 0;
}
</style>
